import * as React from 'react'
import { cn } from '../../lib/utils.js'

export function Badge({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { variant?: 'default' | 'muted' }) {
  return (
    <div
      className={cn(
        'inline-flex items-center rounded-md border border-[var(--border)] px-2 py-0.5 text-xs font-medium text-[var(--ink-muted)]',
        className,
      )}
      {...props}
    />
  )
}
